
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/submission-success",
      function () {
        return require("private-next-pages/us/submission-success.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/submission-success"])
      });
    }
  